import "@hotwired/turbo-rails"
import "bootstrap/dist/js/bootstrap.bundle"
